import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import type { AppProps } from '@/types/app';
import prefetchPresetFeedData from '@/utils/query/prefetchPresetFeedData';

import '@/utils/dev/logger';

export const App = ({ showHeader, hideTrending }: AppProps) => {
  const isOpen = useOpen(() => {
    prefetchPresetFeedData();
  });

  if (!isOpen) {
    return null;
  }

  return <AppContent showHeader={showHeader} hideTrending={hideTrending} />;
};

export default App;
